import gql from 'graphql-tag'

export const GetProducts = () => {
    return gql`query ListProducts($nextToken: String) {
        listProducts(
            input: {
                limit:15,
                nextToken:  $nextToken
                }) {
            items {
                companyDescription
                companyLogo
                companyName
                companyEmail
                price
                images
                productLongDescription
                productName
                productID
                productShortDescription
                tags
                turnaroundTime
            }
            nextToken
        }
    }`
}

export const GetProductDetails = productID => {
    return gql`query ProductDetails {
      productDetails(input: {
        productId: "${productID}"
      })
      {
        companyDescription
        companyLogo
        companyName
        price
        images
        productLongDescription
        productName
        productID
        productShortDescription
        tags
        turnaroundTime
    }
    }`
}

export const StartOrder = () => {
    return gql`mutation startOrder($order:CreateOrderInput){
      createOrder(input:$order){
        orderID
        amount
        currency
        items {
            parent
            quantity
        }
    }}`
}

export const FinishOrder = () => {
    return gql`mutation finishOrder($completeOrder:CompleteOrderInput) {
        completeOrder(input:$completeOrder){
            orderID
            amount
            currency
            items {
                parent
                quantity
            }
        }
    }`
}



// WEBPACK FOOTER //
// ./src/queries/products.js